import { API_FEES, API_IQQA, API_URL, API_URL_COMPLIANCE } from 'utils/constants/enviroments'

import axios from 'axios'

export const getCvuLedger = async ({
  cvuId,
  dateFrom,
  dateTo,
  isExcel,
  page = 1,
  perPage = 10,
  AppliesTo,
  Type,
  amount,
  movId,
}) => {
  try {
    const url = `${API_IQQA}core-ui/cvu-ledger`
    return axios.get(url, {
      headers: {
        cvuId,
        dateFrom,
        dateTo,
        isExcel,
        page,
        perPage,
        AppliesTo,
        Type,
        amount,
        movId,
      },
    })
  } catch (error) {
    throw error
  }
}

export const updateCvuCheck = async data => {
  try {
    const url = `${API_URL}checks/cvu-asign`
    return axios.put(url, data)
  } catch (error) {
    throw error
  }
}

export const getRequestChangeStatus = async (id, data) => {
  try {
    const url = `${API_URL}requests/change-status/${id}`
    return axios.put(url, data)
  } catch (error) {
    throw error
  }
}

export const getRequest = async ({
  company,
  nick,
  email,
  type,
  status,
  id,
  dateFrom,
  dateTo,
  page = 1,
  perPage = 10,
}) => {
  try {
    const url = `${API_URL}requests`
    return axios.get(url, {
      headers: {
        ...(company && { company }),
        ...(nick && { nick }),
        ...(email && { email }),
        ...(type && { type }),
        ...(status && { status }),
        ...(id && { id }),
        ...(dateFrom && { dateFrom }),
        ...(dateTo && { dateTo }),
      },
      params: {
        page,
        perPage,
      },
    })
  } catch (error) {
    throw error
  }
}

export const getCbusByCompany = async id => {
  try {
    const url = `${API_IQQA}banks/company/${id}`
    return axios.get(url)
  } catch (error) {
    throw error
  }
}

export const getChangesChecks = async id => {
  try {
    const url = `${API_URL}elements/workflow/status_changes`
    return axios.get(url, {
      headers: {
        elementType: 'CHECKS',
        elementId: id,
        gmt: '-3',
      },
    })
  } catch (error) {
    throw error
  }
}

export const getCompanies = async () => {
  try {
    const url = `${API_URL}company/list`
    return axios.get(url)
  } catch (error) {
    throw error
  }
}

export const getActivities = async ({
  page,
  perPage,
  search,
  appId,
  email,
  name,
  ip,
  subtype,
  level,
  type,
  dateFrom,
  dateTo,
}) => {
  try {
    const response = await axios.get(`${API_URL}activities`, {
      headers: {
        search,
        appId,
        email,
        name,
        ip,
        subtype,
        level,
        type,
        dateFrom,
        dateTo,
      },
      params: {
        page,
        perPage,
      },
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const changeLanguage = async lang => {
  try {
    const response = await axios.put(`${API_URL}core/users/lang-preferred`, {
      lang,
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const iibbLogsGenerics = async ({ type = 'tax_arg_gross_apply', typeId, page, perPage }) => {
  try {
    const response = await axios.get(`${API_URL}iibb/logsGenerics`, {
      headers: {
        typeId,
        type,
      },
      params: {
        page,
        perPage,
      },
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateAliquots = async (group, data) => {
  try {
    const response = await axios.put(`${API_URL}iibb/aliquots/${group}`, data)
    return response.data
  } catch (error) {
    throw error
  }
}
export const aliquots = async ({ period }) => {
  try {
    const response = await axios.get(`${API_URL}iibb/aliquots`, {
      headers: { period },
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const logout = async () => {
  try {
    const response = await axios.post(`${API_URL}logout`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const taxMaster = async ({ period, jurisdiction, cuit, client, page, perPage }) => {
  try {
    const response = await axios.get(`${API_URL}iibb/gross_master`, {
      headers: {
        period,
        jurisdiction,
        cuit,
        client,
      },
      params: {
        page,
        perPage,
      },
    })
    return response.data
  } catch (error) {
    throw error.response?.data || error
  }
}
export const userTaxArgGross = async ({ userId }) => {
  try {
    const response = await axios.get(`${API_URL}iibb/jurisdiction`, {
      headers: {
        userId,
      },
    })
    return response.data
  } catch (error) {
    throw error.response?.data || error
  }
}

export const transactionFeesAndTaxes = async ({ trxId }) => {
  try {
    const response = await axios.get(`${API_IQQA}cvu/transactionFeesesAndTaxes`, {
      headers: {
        trxid: trxId,
      },
    })
    return response.data
  } catch (error) {
    throw error.response?.data || error
  }
}

export const resetPassword = async ({ requestBy, user_id, key }) => {
  try {
    const response = await axios.post(
      `${API_URL}core/users/reset-password-by-key`,
      {
        requestBy,
        user_id,
      },
      {
        headers: {
          'x-core-key': key,
        },
      }
    )
    return response.data
  } catch (error) {
    throw error
  }
}

export const verifyCodeForResetPassword = async ({ key }) => {
  try {
    const response = await axios.post(`${API_URL}core/users/verify-reset-key`, {
      key,
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const usersCvu = async ({ isExcel, cvuId, page = 1, perPage = 50 }) => {
  try {
    const response = await axios.get(`${API_URL}core/users/cvus`, {
      headers: {
        isExcel,
        cvuId,
        page,
        perPage,
      },
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const stopUserImpersonate = async () => {
  try {
    const response = await axios.get(`${API_URL}core/users/impersonate/stop`)
    return response.data
  } catch (error) {
    throw error
  }
}
export const getUserImpersonate = async ({ token }) => {
  try {
    const response = await axios.get(`${API_URL}core/users/impersonate/login?token=${token}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const impersonateUser = async ({ userId }) => {
  try {
    const response = await axios.post(`${API_URL}core/users/impersonate/start`, null, {
      headers: {
        userId,
      },
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const getStatusHistoryAlert = async ({
  page = 1,
  perPage = 50,
  sort = 'id',
  id,
  direction = 'asc',
}) => {
  try {
    const response = await axios.get(`${API_URL}alerts/${id}/status/history`, {
      params: {
        page,
        perPage,
        sort,
        direction,
      },
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const getTrxTypes = async () => {
  try {
    const response = await axios.get(`${API_IQQA}trxtypes`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const getGeneralSettingsPeriodLimitById = async id => {
  try {
    const response = await axios.get(`${API_IQQA}cvu/period-limit/${id}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const putGeneralSettingsPeriodLimit = async (id, data) => {
  try {
    const response = await axios.put(`${API_IQQA}cvu/period-limit/${id}`, data)
    return response.data
  } catch (error) {
    throw error
  }
}

export const getGeneralSettingsPeriodLimit = async () => {
  try {
    const response = await axios.get(`${API_IQQA}cvu/period-limit`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteGeneralSettings = async id => {
  try {
    const response = await axios.delete(`${API_URL}settings/${id}`)
    return response.data
  } catch (error) {
    throw error
  }
}
export const putGeneralSettings = async (id, data) => {
  try {
    const response = await axios.put(`${API_URL}settings/${id}`, data)
    return response.data
  } catch (error) {
    throw error
  }
}
export const postGeneralSettings = async data => {
  try {
    const response = await axios.post(`${API_URL}settings`, data)
    return response.data
  } catch (error) {
    throw error
  }
}
export const getGeneralSettings = async () => {
  try {
    const response = await axios.get(`${API_URL}settings`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateCbuSettings = async (cbuId, data) => {
  try {
    const response = await axios.put(`${API_IQQA}cvu/cbus/${cbuId}`, data)
    return response.data
  } catch (error) {
    throw error
  }
}
export const createPersonalIdentity = async data => {
  try {
    const response = await axios.post(`${API_IQQA}fortress/personal-identity`, data)
    return response.data
  } catch (error) {
    throw error?.response?.data
  }
}
export const createCustodialAccount = async data => {
  try {
    const response = await axios.post(`${API_IQQA}fortress/custodial-account`, data)
    return response.data
  } catch (error) {
    throw error?.response?.data
  }
}

export const getFortressBalance = async ({ id }) => {
  try {
    const response = await axios.get(`${API_IQQA}fortress/balance/${id}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const getFortressIdentitiesAccounts = async ({
  page = 1,
  perPage = 10,
  identId,
  acctId,
  email,
  nick,
  type,
  identity,
  kycLevel,
  account,
  acctStatus,
  dateFrom,
  dateTo,
  search,
  isExcel,
} = {}) => {
  try {
    const headers = {}
    const add = (k, v) => {
      if (v !== undefined && v !== null && String(v) !== '') headers[k] = v
    }
    add('identId', identId)
    add('acctId', acctId)
    add('email', email)
    add('nick', nick)
    add('type', type)
    add('identity', identity)
    add('kycLevel', kycLevel)
    add('account', account)
    add('acctStatus', acctStatus)
    add('dateFrom', dateFrom)
    add('dateTo', dateTo)
    add('search', search)
    add('isExcel', isExcel)

    const response = await axios.get(`${API_URL}fortress/identities-accounts`, {
      params: { page, perPage },
      headers,
    })

    return response.data
  } catch (error) {
    throw error
  }
}

export const getUserImages = async id => {
  try {
    const response = await axios.get(`${API_URL}compliance/metamap/images/user/${id}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const getAchTransactions = async ({
  page,
  perPage,
  search,
  type,
  status,
  isa,
  amount,
  paymentId,
  transactionId,
  accountFrom,
  accountTo,
  fromEmail,
  toEmail,
  dateFrom,
  dateTo,
  isExcel,
}) => {
  try {
    const response = await axios.get(
      `${API_URL}fortress/trxs_forts?page=${page}&perPage=${perPage}`,
      {
        headers: {
          ...(search && { search }),
          ...(type && { type }),
          ...(status && { status }),
          ...(isa && { isa }),
          ...(amount && { amount }),
          ...(paymentId && { paymentId }),
          ...(transactionId && { transactionId }),
          ...(accountFrom && { accountFrom }),
          ...(accountTo && { accountTo }),
          ...(fromEmail && { fromEmail }),
          ...(toEmail && { toEmail }),
          ...(dateFrom && { dateFrom }),
          ...(dateTo && { dateTo }),
          ...(isExcel && { isExcel }),
        },
      }
    )
    return response.data
  } catch (error) {
    throw error
  }
}

export const flashPermissionsCoris = async id => {
  try {
    const response = await axios.get(`${API_URL}core/coris/user_permissions/${id}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const checkEmail = async ({ email }) => {
  try {
    const response = await axios.get(`${API_URL}users/checkmail`, {
      params: {
        email,
      },
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const createPosQr = async data => {
  try {
    const response = await axios.post(`${API_IQQA}qr/accept/settings/pos`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    return response.data
  } catch (error) {
    throw error
  }
}
export const getAirdrops = async ({ page = 1, perPage = 10, cvuId }) => {
  try {
    const response = await axios.get(`${API_IQQA}cvu/airdrop/trxs`, {
      headers: {
        page,
        cvuId,
        perPage,
      },
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const postAirdrop = async data => {
  try {
    const response = await axios.post(`${API_IQQA}cvu/tests/payout`, data)
    return response.data
  } catch (error) {
    throw error
  }
}

export const getBackList = async id => {
  try {
    const response = await axios.get(`${API_URL_COMPLIANCE}compliance/cvus/blacklist/${id}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteBackList = async id => {
  try {
    const response = await axios.delete(`${API_URL_COMPLIANCE}compliance/cvus/blacklist/${id}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateBackList = async (id, data) => {
  try {
    const response = await axios.put(`${API_URL_COMPLIANCE}compliance/cvus/blacklist/${id}`, data)
    return response.data
  } catch (error) {
    throw error
  }
}
export const getBackListId = async id => {
  try {
    const response = await axios.get(`${API_URL_COMPLIANCE}compliance/cvus/blacklist/${id} `)
    return response.data
  } catch (error) {
    throw error
  }
}

export const createBackList = async data => {
  try {
    const response = await axios.post(`${API_URL_COMPLIANCE}compliance/cvus/blacklist`, data)
    return response.data
  } catch (error) {
    throw error
  }
}

export const getBlackList = async ({ page = 1, perPage = 25, active, taxId }) => {
  try {
    const response = await axios.get(`${API_URL_COMPLIANCE}compliance/cvus/blacklist`, {
      headers: {
        ...(active !== undefined && active !== null && { active }),
        ...(taxId ? { taxId } : {}),
      },
      params: {
        page,
        perPage,
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

export const getCbus = async () => {
  try {
    const response = await axios.get(`${API_IQQA}cbus`)
    return response
  } catch (error) {
    throw error.response?.data || error
  }
}

export const createCvu = async data => {
  try {
    const response = await axios.post(`${API_URL}core/cvu`, data)
    return response
  } catch (error) {
    throw error.response?.data || error
  }
}

export const getRelationsUsers = async ({ id, page, perPage }) => {
  try {
    const response = await axios.get(`${API_URL_COMPLIANCE}compliance/user/${id}/relations`, {
      headers: {
        page,
        perPage,
      },
    })
    return response
  } catch (error) {
    throw error.response?.data || error
  }
}
export const getArcaUsers = async ({ id, page, perPage }) => {
  try {
    const response = await axios.get(`${API_URL_COMPLIANCE}compliance/user/${id}/arca-activities`, {
      headers: {
        page,
        perPage,
      },
    })
    return response
  } catch (error) {
    throw error.response?.data || error
  }
}
export const createNotificationCvu = async data => {
  try {
    const response = await axios.post(`${API_IQQA}transactions/notifications/settings`, data)
    return response
  } catch (error) {
    throw error.response?.data || error
  }
}

export const updateNotificationCvu = async (id, data) => {
  try {
    const response = await axios.put(`${API_IQQA}transactions/notifications/${id}/settings`, data)
    return response
  } catch (error) {
    throw error.response?.data || error
  }
}

export const deleteNotificationById = async id => {
  try {
    const response = await axios.delete(`${API_IQQA}transactions/notifications/${id}/settings`)
    return response
  } catch (error) {
    throw error.response?.data || error
  }
}

export const getCvuNotificationsLogs = async ({ page, perPage, ruleId }) => {
  const pageQuery = `?page=${page}&perPage=${perPage}`
  try {
    const response = await axios.get(`${API_IQQA}transactions/notifications/log${pageQuery}`, {
      headers: {
        ruleId,
      },
    })
    return response.data
  } catch (error) {
    throw error.response?.data || error
  }
}

export const getCvuNotificationsSettings = async ({ page, perPage, id, search, userId, cvuId }) => {
  const pageQuery = `?page=${page}&perPage=${perPage}`
  try {
    const response = await axios.get(`${API_IQQA}transactions/notifications/settings${pageQuery}`, {
      headers: {
        id,
        userId,
        cvuId,
        search,
      },
    })
    return response.data
  } catch (error) {
    throw error.response?.data || error
  }
}

export const getUserFunctionalities = async (id, { page, perPage }) => {
  try {
    const response = await axios.get(`${API_URL}functionalities/${id}/users`, {
      headers: {
        page,
        perPage,
      },
    })
    return response.data
  } catch (error) {
    throw error.response?.data || error
  }
}

export const getRolesFunctionalities = async (id, { page, perPage }) => {
  try {
    const response = await axios.get(`${API_URL}functionalities/${id}/roles`, {
      headers: {
        perPage,
        page,
      },
    })
    return response.data
  } catch (error) {
    throw error.response?.data || error
  }
}

export const disabledCvuCoelsa = async (id, userId) => {
  try {
    const response = await axios.post(`${API_IQQA}cvu/${id}/disable`, {
      requestedBy: userId,
    })
    return response.data
  } catch (error) {
    throw error.response?.data || error
  }
}

export const adjustCvu = async (id, data) => {
  try {
    const response = await axios.post(`${API_IQQA}cvu/adjust`, data, {
      headers: {
        cvuId: id,

        merchant: 'CORE-FRONT',
      },
    })
    return response.data
  } catch (error) {
    throw error.response?.data || error
  }
}

export const updateCvuSettings = async (id, data) => {
  try {
    const response = await axios.put(`${API_IQQA}cvu/cvu_settings`, data, {
      headers: {
        cvuId: id,
      },
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const getAllVerificationsNosis = async ({ page, perPage, from, to, userId }) => {
  let headers = {}
  if (page) {
    headers['page'] = page
  }
  if (perPage) {
    headers['perPage'] = perPage
  }
  if (from) {
    headers['from'] = from
  }
  if (to) {
    headers['to'] = to
  }
  if (userId) {
    headers['userId'] = userId
  }
  const response = await axios.get(`${API_URL_COMPLIANCE}compliance/nosis/verif/all`, {
    headers,
  })
  return response.data
}

export const getRiskMatrix = async riskMatrixId => {
  let headers = {}
  if (riskMatrixId) {
    headers = {
      riskMatrixId,
    }
  }
  try {
    const response = await axios.get(`${API_URL_COMPLIANCE}compliance/risk-matrix`, {
      headers,
    })
    return response.data || []
  } catch (err) {
    throw err
  }
}

export const putRiskMatrix = async data => {
  try {
    const response = await axios.put(`${API_URL_COMPLIANCE}compliance/risk-matrix`, data)
    return response.data || []
  } catch (err) {
    throw err
  }
}
export const postRiskMatrix = async data => {
  try {
    const response = await axios.post(`${API_URL_COMPLIANCE}compliance/risk-matrix`, data)
    return response.data || []
  } catch (err) {
    throw err
  }
}

export const getNationality = async () => {
  try {
    const response = await axios.get(`${API_URL_COMPLIANCE}compliance/nationality-risk`)
    return response.data || []
  } catch (err) {
    return []
  }
}
export const getMatrixTemplate = async () => {
  try {
    const response = await axios.get(`${API_URL_COMPLIANCE}compliance/matrix-template`)
    return response.data || []
  } catch (err) {
    return []
  }
}
export const getAge = async () => {
  try {
    const response = await axios.get(`${API_URL_COMPLIANCE}compliance/age`)
    return response.data || []
  } catch (err) {
    return []
  }
}
export const getGeo = async () => {
  try {
    const response = await axios.get(`${API_URL_COMPLIANCE}compliance/geo`)
    return response.data || []
  } catch (err) {
    return []
  }
}
export const getUserTypes = async () => {
  try {
    const response = await axios.get(`${API_URL_COMPLIANCE}compliance/user-types`)
    return response.data || []
  } catch (err) {
    return []
  }
}
export const getTrxVolume = async () => {
  try {
    const response = await axios.get(`${API_URL_COMPLIANCE}compliance/trx-volume`)
    return response.data || []
  } catch (err) {
    return []
  }
}

export const getArcaActivities = async () => {
  try {
    const response = await axios.get(`${API_URL_COMPLIANCE}compliance/arca-activities`)
    return response.data || []
  } catch (err) {
    return []
  }
}

export const postVerificationsNosis = async id => {
  return await axios.post(
    `${API_URL_COMPLIANCE}compliance/nosis/store-verif`,
    {
      user_id: id,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
}

export const getVerificationsNosis = async ({ userId, page, rowsPerPage, id }) => {
  return await axios.get(`${API_URL_COMPLIANCE}compliance/nosis/verif/${id ?? ''}`, {
    headers: {
      userId,
      page,
      perPage: rowsPerPage,
    },
  })
}

export const validateChallengeLogin = async (email, token) => {
  return await axios.post(`${API_URL}validate-login`, {
    userEmail: email,
    token,
  })
}

export const signIn = async email => {
  return await axios.post(`${API_URL}sign-in`, {
    userEmail: email,
  })
}

export const authSignalAuthenticators = async ({ userId, appId }) => {
  return await axios.get(`${API_URL}auth-signal/authenticators`, {
    headers: {
      appId,
      userId,
    },
  })
}

export const registerAuthSignal = async (email, password) => {
  return await axios.post(`${API_URL}authsignal-register`, {
    userEmail: email,
    userPassword: password,
  })
}

export const deleteAuthenticator = async ({ userId, authenticatorId, appId }) => {
  return await axios.delete(`${API_URL}auth-signal/authenticators`, {
    headers: {
      userId,
      appId,
      authenticatorId,
    },
  })
}
export const authSignalOtpAdmin = async data => {
  return await axios.post(`${API_URL}auth-signal/otp`, data, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export const authSignalTrack = async action => {
  return await axios.post(`${API_URL}auth-signal/track-action`, {
    action: action,
  })
}

export const validUser = async email => {
  try {
    const response = await axios.get(`${API_URL}valid-user`, {
      headers: {
        userEmail: email,
      },
    })
    return response
  } catch (error) {
    throw error.response.data
  }
}

export const validateChallenge = async token => {
  try {
    const response = await axios.post(`${API_URL}auth-signal/validate-challenge`, {
      token,
    })
    return { success: response.data.success, message: response.data.message }
  } catch (err) {
    return []
  }
}

export const getKycStatus = async ({ userId }) => {
  try {
    const response = await axios.get(`${API_URL_COMPLIANCE}compliance/kyc-status`, {
      headers: { userId },
    })
    return response.data || []
  } catch (err) {
    return []
  }
}
export const getKycVerifications = async ({ userId }) => {
  try {
    const response = await axios.get(`${API_URL_COMPLIANCE}compliance/kyc-verifications`, {
      headers: { userId },
    })
    return response.data || []
  } catch (err) {
    return []
  }
}

export const getKycLogs = async ({ userId }) => {
  try {
    const response = await axios.get(`${API_URL_COMPLIANCE}compliance/kyc-logs`, {
      headers: { userId },
    })
    return response.data || []
  } catch (err) {
    return []
  }
}

export const getTransactionsCards = async ({
  cardtrxid,
  cardid,
  trxid,
  cvuid,
  status,
  trxtype,
  type,
  dateFrom,
  dateTo,
  perPage,
  page,
}) => {
  try {
    const queryParams = `?page=${page}&perPage=${perPage}`
    const response = await axios.get(`${API_URL}cards/v2/transactions${queryParams}`, {
      headers: {
        ...(cardtrxid && { cardtrxid }),
        ...(cardid && { cardid }),
        ...(trxid && { trxid }),
        ...(cvuid && { cvuid }),
        ...(status && { status }),
        ...(trxtype && { trxtype }),
        ...(type && { type }),
        ...(dateFrom && { dateFrom }),
        ...(dateTo && { dateTo }),
      },
    })

    return response.data
  } catch (err) {
    throw err
  }
}
export const getCards = async ({
  email,
  lastFour,
  holdername,
  status,
  page = 1,
  perPage,
  cardId,
}) => {
  try {
    const response = await axios.get(`${API_URL}cards?page=${page}`, {
      headers: {
        email,
        lastFour,
        holdername,
        cardId,
        status,
        perPage,
      },
    })
    return response.data
  } catch (err) {
    throw err
  }
}

export const matchConciliation = async ({ trxId, externalId }) => {
  try {
    const response = await axios.post(
      `${API_IQQA}cvu/conciliation/match`,
      { trxId, externalId },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    return response
  } catch (err) {
    return []
  }
}

export const unMatchConciliation = async id => {
  try {
    const response = await axios.delete(`${API_IQQA}cvu/conciliation/unmatch/${id}`)
    return response
  } catch (err) {
    return []
  }
}

export const getConciliations = async ({
  dateFrom,
  dateTo,
  trxType,
  matched,
  taxId,
  coelsaId,
  amount,
  page,
  perPage,
}) => {
  try {
    const response = await axios.get(`${API_IQQA}conciliation-view`, {
      headers: {
        'Content-Type': 'application/json',
        dateFrom,
        trxType,
        dateTo,
        coelsaId,
        amount,
        matched,
        taxId,
        page,
        perPage,
      },
    })
    return response
  } catch (error) {
    return []
  }
}

export const getCvuDetails = async id => {
  const response = await axios.get(`${API_IQQA}cvu/${id}`)
  return response.data || []
}

export const getAlertById = async id => {
  const response = await axios.get(`${API_URL_COMPLIANCE}compliance/alerts/${id}`, {
    headers: {
      Accept: 'application/json',
    },
  })
  return response.data || []
}

export const getTransactionsByAlert = async ({ id, perPage }) => {
  const response = await axios.get(`${API_URL_COMPLIANCE}compliance/alerts/${id}/transactions`, {
    headers: {
      perPage,
    },
  })
  return response.data || []
}

export const getTransactions = async ({
  trxId,
  page,
  perPage,
  search,
  type,
  status,
  cvuId,
  dateFrom,
  dateTo,
  amount,
}) => {
  const response = await axios.get(`${API_IQQA}core-ui/transactions`, {
    headers: {
      ...(trxId && { trxId }),
      ...(search && { search }),
      ...(type && { type }),
      ...(status && { status }),
      ...(cvuId && { cvuId }),
      ...(dateFrom && { dateFrom }),
      ...(dateTo && { dateTo }),
      ...(amount && { amount }),
      ...(page && { page }),
      ...(perPage && { perPage }),
    },
  })
  return response.data || []
}

export const getAlertsByType = async ({ type = 'alert', page = 1, perPage = 50, status }) => {
  const response = await axios.get(`${API_URL_COMPLIANCE}compliance/alerts?page=${page}`, {
    headers: {
      type: 'risk',
      status,
      Accept: 'application/json',
      perPage,
    },
  })
  return response.data || []
}

export const getNotesById = async ({ id, elementType }) => {
  try {
    const response = await axios.get(`${API_URL}note/${id}`, {
      params: { elementType },
    })
    return response.data || []
  } catch (error) {
    return { status: false, data: [] }
  }
}

export const createNote = async data => {
  try {
    const noteData = {
      ...data,
      relatesToElemId: 1,
    }
    const response = await axios.post(`${API_URL}note`, noteData, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    return response.data || []
  } catch (error) {
    throw error
  }
}

export const getRoles = async () => {
  try {
    const response = await axios.get(`${API_URL}roles`)
    return response.data || []
  } catch (error) {
    throw error
  }
}

export const getRolesSearch = async ({ search = '', page = 1, limit = 10 }) => {
  try {
    const response = await axios.get(`${API_URL}roles/search/`, {
      params: { search, page, limit },
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const getRolesByUser = async id => {
  const response = await axios.get(`${API_URL}roles/byuser/${id}`)
  return response.data || [] // Asegura que siempre se devuelva un array
}

export const createRole = async roleData => {
  try {
    const response = await axios.post(`${API_URL}roles`, roleData)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateRole = async (id, roleData) => {
  const response = await axios.put(`${API_URL}roles/${id}`, roleData)
  return response.data || {}
}

export const deleteRole = async id => {
  const response = await axios.delete(`${API_URL}roles/${id}`)
  return response.data || {}
}

export const getApps = async () => {
  const response = await axios.get(`${API_URL}apps`)
  return response.data || []
}

export const getAppsByNotes = async userId => {
  const response = await axios.get(`${API_URL}appsbynotes`, {
    params: { userId },
  })
  return response.data || []
}

export const getFeeDistributions = async ({ feeId, cvuId }) => {
  let headers = {}
  if (feeId) headers['feeId'] = feeId
  if (cvuId) headers['cvuId'] = cvuId
  const response = await axios.get(`${API_URL}fees_core/fee-dist`, {
    headers,
  })

  return response.data || []
}

export const updateFeeDistribution = async (id, data) => {
  try {
    const response = await axios.put(`${API_FEES}fees-dist-distribution/${id}`, data)
    return response.data
  } catch (error) {
    throw error?.response?.data
  }
}

export const getAppsByFees = async userId => {
  const response = await axios.get(`${API_URL}appsbyfees`, {
    headers: {
      userid: userId, // Aquí se agrega el userId en los headers
    },
  })

  return response.data || []
}

export const createFees = async feesData => {
  try {
    const response = await axios.post(`${API_URL}fees_core`, feesData)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateFees = async (id, feesData) => {
  try {
    const response = await axios.put(`${API_URL}fees_core/${id}`, feesData)
    return response.data || {}
  } catch (error) {
    throw error
  }
}

export const createApp = async roleData => {
  const response = await axios.post(`${API_URL}apps`, roleData)
  return response.data || {}
}

export const updateApp = async (id, roleData) => {
  const response = await axios.put(`${API_URL}apps/${id}`, roleData)
  return response.data || {}
}

export const deleteApp = async id => {
  const response = await axios.delete(`${API_URL}apps/${id}`)
  return response.data || {}
}

export const getFunctionalities = async () => {
  const response = await axios.get(`${API_URL}functionalities`)
  return response.data || []
}

/*

// Funciones de API
export const searchDefaultSettings = async (filters) => {
  const response = await axios.get(`${API_URL}fees_core/defaultsettings`, { 
    params: filters // Usa los filtros como parámetros de consulta
  });
  return response.data || []; // Asegura que siempre se devuelva un array
};

*/

export const getFunctionality = async id => {
  const response = await axios.get(`${API_URL}functionalities/id/${id}`)
  return response.data || []
}

export const getFunctionalitiesSearch = async ({
  search = '',
  page = 1,
  limit = 10,
  appId = null,
}) => {
  try {
    const response = await axios.get(`${API_URL}functionalities`, {
      params: { search, page, limit, appId },
    })
    return {
      users: response.data || [],
      totalPages:
        response.headers['x-total-pages'] || Math.ceil((response.data?.total || 0) / limit),
    }
  } catch (error) {
    console.error('Error fetching users:', error)
    return { users: [], totalPages: 0 }
  }
}

export const createFunctionality = async functionalityData => {
  const response = await axios.post(`${API_URL}functionalities`, functionalityData)
  return response.data || {}
}

export const updateFunctionality = async (id, functionalityData) => {
  const response = await axios.put(`${API_URL}functionalities/${id}`, functionalityData)
  return response.data || {}
}

export const deleteFunctionality = async id => {
  const response = await axios.delete(`${API_URL}functionalities/${id}`)
  return response.data || {}
}

export const getUsersRoles = async () => {
  const response = await axios.get(`${API_URL}userroles`)
  return response.data || []
}

export const createUserRoles = async roleData => {
  const response = await axios.post(`${API_URL}userroles`, roleData)
  return response.data || {}
}

export const updateUserRoles = async (id, roleData) => {
  const response = await axios.put(`${API_URL}userroles/id/${id}`, roleData)
  return response.data || {}
}

export const deleteUserRoles = async id => {
  const response = await axios.delete(`${API_URL}userroles/id/${id}`)
  return response.data || {}
}

export const deleteUserRolesAll = async id => {
  const response = await axios.delete(`${API_URL}userroles/${id}`)
  return response.data || {}
}

export const getRolesForUser = async id => {
  const response = await axios.get(`${API_URL}userroles/${id}`)
  return response.data || []
}

// Nueva función para obtener todos los usuarios sin paginación
export const getAllUsers = async () => {
  try {
    const response = await axios.get(`${API_URL}users/all`)
    // console.log('API response for all users:', response.data);
    const users = Array.isArray(response.data) ? response.data : response.data?.users || []
    return users
  } catch (error) {
    console.error('Error fetching all users:', error)
    return [] // Retorna un array vacío en caso de error
  }
}

export const getUsers = async ({ search = '', page = 1, limit = 10, userId, role }) => {
  try {
    const response = await axios.get(`${API_URL}users`, {
      params: { search, page, limit, userId },
      headers: {
        role,
      },
    })
    return response?.data
  } catch (error) {
    throw error
  }
}

export const getUser = async id => {
  const response = await axios.get(`${API_URL}users/${id}`)
  return response.data || {}
}

export const createUser = async data => {
  try {
    const response = await axios.post(`${API_URL}core/users`, data)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateUser = async (id, roleData) => {
  const response = await axios.put(`${API_URL}users/${id}`, roleData)
  return response.data || {}
}

export const deleteUser = async id => {
  const response = await axios.delete(`${API_URL}users/${id}`)
  return response.data || {}
}

export const getCodesFor = async type => {
  const response = await axios.get(`${API_URL}codesfor/${type}`)
  return response.data || []
}

// Funciones de API
export const getComplianceProfile = async id => {
  const response = await axios.get(`${API_URL}complianceprofiles`)
  return response.data || {}
}

export const getAllUserAddresses = async ({ userId, search = '', page = 1, limit = 10 }) => {
  try {
    const response = await axios.get(`${API_URL}user_addresses/all/${userId}`, {
      params: { search, page, limit },
    })
    // console.log('API response:', response.data);
    return {
      users: response.data || [],
      totalPages:
        response.headers['x-total-pages'] || Math.ceil((response.data?.total || 0) / limit),
    }
  } catch (error) {
    console.error('Error fetching users:', error)
    return { users: [], totalPages: 0 }
  }
}

/*

// Servicios para gestionar direcciones de usuario
export const getAllUserAddresses = async (userId) => {  // Id de usuario obtener su address

  // console.log("obtiene los address");
  const response = await axios.get(`${API_URL}user_addresses/all/${userId}`);
  return response.data || [];
};

*/

export const getUserAddresses = async userId => {
  //  Id de address
  const response = await axios.get(`${API_URL}user_addresses/${userId}`)
  return response.data || []
}

export const createUserAddress = async (userId, addressData) => {
  const response = await axios.post(`${API_URL}user_addresses`, addressData)
  return response.data || {}
}

export const updateUserAddress = async (addressId, addressData) => {
  const response = await axios.put(`${API_URL}user_addresses/id/${addressId}`, addressData)
  return response.data || {}
}

export const deleteUserAddress = async addressId => {
  const response = await axios.delete(`${API_URL}user_addresses/${addressId}`)
  return response.data || {}
}

export const deleteUserAddressId = async addressId => {
  const response = await axios.delete(`${API_URL}user_addresses/id/${addressId}`)
  return response.data || {}
}

export const getUserDocs = async userId => {
  const response = await axios.get(`${API_URL}user_docs/${userId}`)
  return response.data || []
}

export const createUserDocs = async userDocs => {
  try {
    const response = await axios.post(`${API_URL}user_docs`, userDocs)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateUserDocsId = async (addressId, userDocs) => {
  const response = await axios.put(`${API_URL}user_docs/${addressId}`, userDocs)
  return response.data || {}
}

export const updateUserDocs = async (addressId, userDocs) => {
  try {
    const response = await axios.put(`${API_URL}user_docs/${addressId}`, userDocs)
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteUserDocs = async addressId => {
  const response = await axios.delete(`${API_URL}user_docs/${addressId}`)
  return response.data || {}
}

// Funciones de API
export const getCountries = async id => {
  let url = ''
  if (id) {
    url = `${API_URL}countries/${id}`
  } else {
    url = `${API_URL}countries`
  }
  const response = await axios.get(url)
  return response.data || []
}

export const getAllUserApps = async ({ userId, search = '', page = 1, limit = 10 }) => {
  try {
    const response = await axios.get(`${API_URL}userapps/all/${userId}`, {
      params: { search, page, limit },
    })
    return response
  } catch (error) {
    return { error }
  }
}

export const getUserApp = async userId => {
  //  Id de address
  const response = await axios.get(`${API_URL}userapps/${userId}`)
  return response.data || []
}

export const createUserApp = async (userId, addressData) => {
  const response = await axios.post(`${API_URL}userapps`, addressData)
  return response.data || {}
}

export const updateUserApp = async (addressId, addressData) => {
  const response = await axios.put(`${API_URL}userapps/id/${addressId}`, addressData)
  return response.data || {}
}

/*
export const deleteUserApp = async (addressId) => {
  const response = await axios.delete(`${API_URL}user_addresses/${addressId}`);
  return response.data || {};
};

*/

export const deleteUserAppId = async addressId => {
  const response = await axios.delete(`${API_URL}userapps/id/${addressId}`)
  return response.data || {}
}

// Docs

export const getAllUserDocs = async ({ userId, search = '', page = 1, limit = 10 }) => {
  try {
    const response = await axios.get(`${API_URL}user_docs/all/${userId}`, {
      params: { search, page, limit },
    })
    // console.log('API response:', response.data);
    return {
      users: response.data || [],
      totalPages:
        response.headers['x-total-pages'] || Math.ceil((response.data?.total || 0) / limit),
    }
  } catch (error) {
    console.error('Error fetching users:', error)
    return { users: [], totalPages: 0 }
  }
}

export const getUserDoc = async userId => {
  //  Id de address
  const response = await axios.get(`${API_URL}user_docs/${userId}`)
  return response.data || []
}

export const createUserDoc = async (userId, addressData) => {
  // console.log(addressData,'addressDatazzzzz');

  const response = await axios.post(`${API_URL}user_docs`, addressData)
  return response.data || {}
}

export const updateUserDoc = async (addressId, addressData) => {
  const response = await axios.put(`${API_URL}user_docs/id/${addressId}`, addressData)
  return response.data || {}
}

/*
export const deleteUserDoc = async (addressId) => {
  const response = await axios.delete(`${API_URL}user_docs/${addressId}`);
  return response.data || {};
};

*/

export const deleteUserDocId = async (id, userId) => {
  const response = await axios.delete(`${API_URL}user_docs/${userId}`, {
    headers: {
      docId: id,
    },
  })
  return response.data || {}
}

// Roles

export const getRolesAllForUser = async ({ userId, search = '', page = 1, limit = 10 }) => {
  try {
    const response = await axios.get(`${API_URL}userroles/all/${userId}`, {
      params: { search, page, limit },
    })
    // console.log('API response:', response.data);
    return {
      users: response.data || [],
      totalPages:
        response.headers['x-total-pages'] || Math.ceil((response.data?.total || 0) / limit),
    }
  } catch (error) {
    console.error('Error fetching users:', error)
    return { users: [], totalPages: 0 }
  }
}

export const getUserRole = async userId => {
  //  Id de address
  const response = await axios.get(`${API_URL}userroles/${userId}`)
  return response.data || []
}

export const getUsersRolesSearch = async ({ search = '', page = 1, limit = 10 }) => {
  try {
    const response = await axios.get(`${API_URL}userroles`, {
      params: { search, page, limit },
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const createUserRole = async data => {
  try {
    const response = await axios.post(`${API_URL}userroles`, data)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateUserRole = async (addressId, addressData) => {
  const response = await axios.put(`${API_URL}userroles/id/${addressId}`, addressData)
  return response.data || {}
}

export const deleteUserRoleId = async addressId => {
  const response = await axios.delete(`${API_URL}userroles/id/${addressId}`)
  return response.data || {}
}

//  Notes

// Funciones de API
export const getNotes = async () => {
  const response = await axios.get(`${API_URL}roles`)
  return response.data || [] // Asegura que siempre se devuelva un array
}

export const getNotesForUser = async id => {
  const response = await axios.get(`${API_URL}userroles/${id}`)
  return response.data || []
}

export const getNotesAllForUser = async ({ userId, search = '', page = 1, limit = 10 }) => {
  try {
    const response = await axios.get(`${API_URL}userroles/all/${userId}`, {
      params: { search, page, limit },
    })
    // console.log('API response:', response.data);
    return {
      users: response.data || [],
      totalPages:
        response.headers['x-total-pages'] || Math.ceil((response.data?.total || 0) / limit),
    }
  } catch (error) {
    console.error('Error fetching users:', error)
    return { users: [], totalPages: 0 }
  }
}

export const getNotesByAppList = async (appId, userId) => {
  try {
    const response = await axios.get(`${API_URL}users/notesbyapp`, {
      headers: {
        app: appId,
        userid: userId,
      },
    }) // Asegúrate de que este cierre sea correcto
    return response.data
  } catch (error) {
    throw new Error('Error fetching notes by app: ' + error.message)
  }
}

/*

export const getNotesByAppList = async (app, userid) => { const response = await axios.get(`${API_URL}users/notesbyapp`);
  return response.data || [];
};

*/

// News

// Funciones de API
export const getNews = async () => {
  const response = await axios.get(`${API_URL}roles`)
  return response.data || [] // Asegura que siempre se devuelva un array
}

export const getNewsForUser = async id => {
  const response = await axios.get(`${API_URL}userroles/${id}`)
  return response.data || []
}

export const getNewsAllForUser = async ({ userId, search = '', page = 1, limit = 10 }) => {
  try {
    const response = await axios.get(`${API_URL}userroles/all/${userId}`, {
      params: { search, page, limit },
    })
    // console.log('API response:', response.data);
    return {
      users: response.data || [],
      totalPages:
        response.headers['x-total-pages'] || Math.ceil((response.data?.total || 0) / limit),
    }
  } catch (error) {
    console.error('Error fetching users:', error)
    return { users: [], totalPages: 0 }
  }
}

export const getNewsByAppList = async (appId, userId) => {
  try {
    const response = await axios.get(`${API_URL}users/newsbyapp`, {
      headers: {
        app: appId,
        userid: userId,
      },
    }) // Asegúrate de que este cierre sea correcto
    return response.data
  } catch (error) {
    throw new Error('Error fetching notes by app: ' + error.message)
  }
}

export const getCompliance = async () => {
  const response = await axios.get(`${API_URL}roles`)
  return response.data || [] // Asegura que siempre se devuelva un array
}

export const getComplianceForUser = async id => {
  const response = await axios.get(`${API_URL}userroles/${id}`)
  return response.data || []
}

export const getComplianceAllForUser = async ({ userId, search = '', page = 1, limit = 10 }) => {
  try {
    const response = await axios.get(`${API_URL}userroles/all/${userId}`, {
      params: { search, page, limit },
    })
    return {
      users: response.data || [],
      totalPages:
        response.headers['x-total-pages'] || Math.ceil((response.data?.total || 0) / limit),
    }
  } catch (error) {
    console.error('Error fetching users:', error)
    return { users: [], totalPages: 0 }
  }
}

// Funciones de API

export const getFeeById = async id => {
  const response = await axios.get(`${API_URL}fees/id/${id}`)
  return response.data || {}
}

export const getFees = async () => {
  const response = await axios.get(`${API_URL}roles`)
  return response.data || [] // Asegura que siempre se devuelva un array
}

export const getFeesForUser = async id => {
  const response = await axios.get(`${API_URL}userroles/${id}`)
  return response.data || []
}

export const getFeesAllForUser = async ({ userId, search = '', page = 1, limit = 10 }) => {
  try {
    const response = await axios.get(`${API_URL}userroles/all/${userId}`, {
      params: { search, page, limit },
    })
    // console.log('API response:', response.data);
    return {
      users: response.data || [],
      totalPages:
        response.headers['x-total-pages'] || Math.ceil((response.data?.total || 0) / limit),
    }
  } catch (error) {
    console.error('Error fetching users:', error)
    return { users: [], totalPages: 0 }
  }
}

// Funciones de API
export const getMethods = async () => {
  const response = await axios.get(`${API_URL}methods`)
  return response.data || []
}

// Funciones de API
export const getConcepts = async () => {
  const response = await axios.get(`${API_URL}concepts`)
  return response.data || []
}

export const getConceptsCvu = async () => {
  try {
    const response = await axios.get(`${API_IQQA}cvu/concepts`)
    return response.data || []
  } catch (error) {
    throw error
  }
}

export const getFeesByAppList = async userId => {
  try {
    const response = await axios.get(`${API_URL}users/feesbyapp`, {
      headers: {
        app: null,
        userid: userId,
      },
    })
    return response.data
  } catch (error) {
    throw new Error('Error fetching notes by app: ' + error.message)
  }
}

export const searchCustomSettings = async filters => {
  try {
    const response = await axios.get(`${API_URL}fees_core/customsettings`, {
      params: filters,
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const createCustomSetting = async roleData => {
  const response = await axios.post(`${API_URL}roles`, roleData)
  return response.data || {}
}

export const updateCustomSetting = async (id, roleData) => {
  const response = await axios.put(`${API_URL}roles/${id}`, roleData)
  return response.data || {}
}

export const deleteCustomSetting = async id => {
  const response = await axios.delete(`${API_URL}fees_core/${id}`)
  return response.data || {}
}

export const searchDefaultSettings = async filters => {
  try {
    const response = await axios.get(`${API_URL}fees_core/defaultsettings`, {
      params: filters,
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const createDefaultSetting = async roleData => {
  const response = await axios.post(`${API_URL}roles`, roleData)
  return response.data || {}
}

export const updateDefaultSetting = async (id, roleData) => {
  const response = await axios.put(`${API_URL}roles/${id}`, roleData)
  return response.data || {}
}

export const deleteDefaultSetting = async id => {
  const response = await axios.delete(`${API_URL}roles/${id}`)
  return response.data || {}
}

// Funciones de API
export const searchVerifications = async filters => {
  const response = await axios.get(`${API_URL}verifications`, {
    params: filters,
  })
  return response.data || []
}

// Funciones de API
export const searchVerificationsByItem = async id => {
  const response = await axios.get(`${API_URL}verifications/byItem/${id}`)
  return response.data || []
}

export const createVerification = async roleData => {
  const response = await axios.post(`${API_URL}roles`, roleData)
  return response.data || {}
}

export const updateVerification = async (id, roleData) => {
  const response = await axios.put(`${API_URL}roles/${id}`, roleData)
  return response.data || {}
}

export const deleteVerification = async id => {
  const response = await axios.delete(`${API_URL}roles/${id}`)
  return response.data || {}
}

/*

// Funciones de API
export const getComplianceProfile = async (id) => {
  const response = await axios.get(`${API_URL}complianceprofiles`);
  return response.data || {};
};


// Funciones de API
export const searchProfiles = async (filters) => {
  const response = await axios.get(`${API_URL}profiles`, { 
    params: filters // Usa los filtros como parámetros de consulta
  });
  return response.data || []; // Asegura que siempre se devuelva un array
};

*/
export const searchProfiles = async filters => {
  //  ya obtiene estos datos  en getComplianceProfile
  const response = await axios.get(`${API_URL}profiles`, {
    params: filters, // Usa los filtros como parámetros de consulta
  })
  return response.data || [] // Asegura que siempre se devuelva un array
}

// Funciones de API
export const searchProfilesByItem = async id => {
  const response = await axios.get(`${API_URL}profiles/byItem/${id}`)
  return response.data || [] // Asegura que siempre se devuelva un array
}

export const createProfile = async roleData => {
  const response = await axios.post(`${API_URL}roles`, roleData)
  return response.data || {}
}

export const updateProfile = async (id, roleData) => {
  const response = await axios.put(`${API_URL}roles/${id}`, roleData)
  return response.data || {}
}

export const deleteProfile = async id => {
  const response = await axios.delete(`${API_URL}roles/${id}`)
  return response.data || {}
}

// Rule

export const getRules = async ({ page = 1, perPage = 50, cvu, nick, type }) => {
  const response = await axios.get(`${API_URL}complianceprofilesrules`, {
    params: {
      page,
      perPage,
    },
    headers: {
      cvu,
      nick,
      type,
    },
  })
  return response.data || []
}

export const getRuleById = async id => {
  try {
    const response = await axios.get(`${API_URL}complianceprofilesrules/${id}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const createRule = async roleData => {
  const response = await axios.post(`${API_URL}complianceprofilesrules`, roleData)
  return response.data || {}
}

export const updateRule = async (id, roleData) => {
  const response = await axios.put(`${API_URL}complianceprofilesrules/${id}`, roleData)
  return response.data || {}
}

export const deleteRule = async id => {
  const response = await axios.delete(`${API_URL}complianceprofilesrules/${id}`)
  return response.data || {}
}

// Alert

export const getAlerts = async () => {
  const response = await axios.get(`${API_URL}compliancealerts`)
  return response.data || []
}

export const getAlertsByRule = async (id, searchTerm = '', status = '') => {
  const params = new URLSearchParams({
    search: searchTerm,
    status: status.toUpperCase(), // Asegúrate de enviar el estado en mayúsculas
  })
  const response = await axios.get(`${API_URL}compliancealerts/alerts/${id}?${params.toString()}`)
  return response.data || []
}

/*

export const getAlertsByRule = async (id) => {
  const response = await axios.get(`${API_URL}compliancealerts/alerts/${id}`);
  return response.data || [];
};

*/

export const createAlert = async roleData => {
  const response = await axios.post(`${API_URL}compliancealerts`, roleData)
  return response.data || {}
}

export const updateAlert = async (id, roleData) => {
  const response = await axios.put(`${API_URL}compliancealerts/${id}`, roleData)
  return response.data || {}
}

/*

export const updateAlert = async (id, roleData) => {
  const response = await axios.put(`${API_URL}compliancealerts/${id}`, roleData);
  return response.data || {};
};

*/

export const deleteAlert = async id => {
  const response = await axios.delete(`${API_URL}compliancealerts/${id}`)
  return response.data || {}
}

export const getAppsAlerts = async () => {
  const response = await axios.get(`${API_URL}apps/alerts`)
  return response.data || []
}

export const getAllUsersAlerts = async () => {
  try {
    const response = await axios.get(`${API_URL}users/all_alerts`)
    // console.log('API response for all users:', response.data);
    const users = Array.isArray(response.data) ? response.data : response.data?.users || []
    return users
  } catch (error) {
    console.error('Error fetching all users:', error)
    return [] // Retorna un array vacío en caso de error
  }
}

// Obtener usuarios filtrados por application_id
export const getUsersByAppId = async appId => {
  try {
    const response = await axios.get(`${API_URL}apps/${appId}/users`)
    return response.data || []
  } catch (error) {
    console.error(`Error fetching users for app ${appId}:`, error)
    return []
  }
}

// Obtener aplicaciones filtradas por user_id
export const getAppsByUserId = async userId => {
  try {
    const response = await axios.get(`${API_URL}users/${userId}/apps`)
    return response.data || []
  } catch (error) {
    console.error(`Error fetching apps for user ${userId}:`, error)
    return []
  }
}

export const promoteFunctionality = async roleData => {
  try {
    const appDescription = roleData?.data?.app?.description
    const fullData = JSON.stringify(roleData)

    const response = await axios.post(
      `${API_URL}functionalities/promove`,
      {},
      {
        headers: {
          app: appDescription,
          data: fullData,
        },
      }
    )

    return response.data || {}
  } catch (error) {
    console.error('Error in promotion:', error)
    if (error.response) {
      // Si hay una respuesta del servidor con error
      throw new Error(error.response.data.message || 'Unknown error occurred')
    }
    throw error
  }
}

export const promoverRole = async roleData => {
  try {
    const response = await axios.post(
      `${API_URL}roles/promove`, // URL del endpoint
      roleData, // Aquí se envía el objeto roleData en el body
      {
        headers: {
          'Content-Type': 'application/json', // Indica que estás enviando JSON
        },
      }
    )

    return response.data || {}
  } catch (error) {
    console.error('Error in promotion:', error)
    if (error.response) {
      // Si hay una respuesta del servidor con error
      throw new Error(error.response.data.message || 'Unknown error occurred')
    }
    throw error
  }
}

/*

export const promoverRole = async (roleData) => {
  try {
    const appDescription = roleData?.data?.app?.description;
    const fullData = JSON.stringify(roleData);


    console.log(fullData);

    const response = await axios.post(
      `${API_URL}roles/promove`,
      {}, // Cuerpo vacío
      {
        headers: {
          app: appDescription,
          data: fullData,
        },
      }
    );


    return response.data || {};
  } catch (error) {
    console.error("Error in promotion:", error);
    if (error.response) {
      // Si hay una respuesta del servidor con error
      throw new Error(error.response.data.message || 'Unknown error occurred');
    }
    throw error;
  }
};

*/

// Scopes

export const getScopes = async () => {
  const response = await axios.get(`${API_URL}scopes`)
  return response.data || [] // Asegura que siempre se devuelva un array
}

export const getScopesSearch = async ({ search = '', page = 1, limit = 10 }) => {
  try {
    const response = await axios.get(`${API_URL}scopes/search/`, {
      params: { search, page, limit },
    })

    return {
      data: response.data || [],
      totalPages:
        response.headers['x-total-pages'] || Math.ceil((response.data?.data?.total || 0) / limit),
    }
  } catch (error) {
    console.error('Error fetching users:', error)
    return { users: [], totalPages: 0 }
  }
}

export const getScopesByUser = async id => {
  const response = await axios.get(`${API_URL}scopes/byuser/${id}`)
  return response.data || [] // Asegura que siempre se devuelva un array
}

export const createUserAppScope = async roleData => {
  try {
    const response = await axios.post(`${API_URL}scopes`, roleData, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    return response.data || {}
  } catch (error) {
    console.error('Error creating user app scope:', error)
    throw error
  }
}

export const updateScope = async (id, roleData) => {
  const response = await axios.put(`${API_URL}scopes/${id}`, roleData)
  return response.data || {}
}

export const deleteScope = async id => {
  const response = await axios.delete(`${API_URL}scopes/${id}`)
  return response.data || {}
}

// Alerts

export const getAlertsSingle = async () => {
  // getAlerts
  const response = await axios.get(`${API_URL}alerts`)
  return response.data || [] // Asegura que siempre se devuelva un array
}

export const getAlertsTrx = async id => {
  // getAlerts
  const response = await axios.get(`${API_URL}alerts/trx/${id}`)
  return response.data || [] // Asegura que siempre se devuelva un array
}

export const getAlertsSearch = async ({
  search = '',
  page = 1,
  perPage = 10,
  status = '',
  minLevel = 0,
  maxLevel = 100,
}) => {
  try {
    const response = await axios.get(`${API_URL}alerts/search/`, {
      params: { search, page, perPage, status, minLevel, maxLevel },
    })
    return response || []
  } catch (error) {
    return { data: [] }
  }
}

export const getAlertsByUser = async id => {
  const response = await axios.get(`${API_URL}alerts/byuser/${id}`)
  return response.data || [] // Asegura que siempre se devuelva un array
}

export const createUserAppAlert = async roleData => {
  try {
    const response = await axios.post(`${API_URL}alerts`, roleData, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    return response.data || {}
  } catch (error) {
    console.error('Error creating user app alert:', error)
    throw error
  }
}

export const updateAlertSingle = async (id, roleData) => {
  // updateAlert
  const response = await axios.put(`${API_URL}alerts/${id}`, roleData)
  return response.data || {}
}

export const deleteAlertSingle = async id => {
  // deleteAlert
  const response = await axios.delete(`${API_URL}alerts/${id}`)
  return response.data || {}
}

// Checks

// Funciones de API
export const getChecks = async () => {
  const response = await axios.get(`${API_URL}checks`)
  return response.data || [] // Asegura que siempre se devuelva un array
}

export const getCvus = async ({
  page = 1,
  perPage = 25,
  search,
  userId,
  cvuId,
  email,
  alias,
  cuit,
  owner,
  active,
  cvu,
  companyDescription,
}) => {
  const response = await axios.get(`${API_URL}checks/cvu`, {
    headers: {
      search,
      perPage,
      userId,
      cvuId,
      page,
      email,
      alias,
      cuit,
      owner,
      active,
      cvu,
      companyDescription,
    },
  })
  return response.data || []
}

export const getBanks = async () => {
  const response = await axios.get(`${API_URL}checks/bank`)
  return response.data || [] // Asegura que siempre se devuelva un array
}

export const getChecksSearch = async ({
  search = '',
  page = 1,
  limit = 10,
  status = '',
  cvu = '',
  email = '',
  bank_id = '',
  id,
}) => {
  try {
    const response = await axios.get(`${API_URL}checks/search/`, {
      params: { search, page, limit, status, cvu, email, bank_id, id },
    })
    return response
  } catch (error) {
    return { data: [], totalPages: 0 }
  }
}

export const createCheck = async roleData => {
  const response = await axios.post(`${API_URL}checks`, roleData)
  return response.data || {}
}

export const updateCheck = async (id, roleData) => {
  const response = await axios.put(`${API_URL}checks/${id}`, roleData)
  return response.data || {}
}

export const deleteCheck = async id => {
  const response = await axios.delete(`${API_URL}checks/${id}`)
  return response.data || {}
}

export const getTypesSearch = async ({ search = '', page = 1, limit = 10, appId = null }) => {
  try {
    const params = { search, page, limit }
    if (appId) params.appId = appId

    const response = await axios.get(`${API_URL}elemtypes/`, { params })

    return response.data
  } catch (error) {
    throw error
  }
}

export const createType = async roleData => {
  try {
    const response = await axios.post(`${API_URL}elemtypes`, roleData, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    return response.data || {}
  } catch (error) {
    console.error('Error creating user app scope:', error)
    throw error
  }
}

export const updateType = async (id, roleData) => {
  const response = await axios.put(`${API_URL}elemtypes/${id}`, roleData)
  return response.data || {}
}

export const deleteType = async id => {
  const response = await axios.delete(`${API_URL}elemtypes/${id}`)
  return response.data || {}
}

//  SubTypes

export const getSubtypes = async () => {
  const response = await axios.get(`${API_URL}elemsubtypes`)
  return response.data || [] // Asegura que siempre se devuelva un array
}

export const getSubtypesSearch = async ({
  search = '',
  page = 1,
  limit = 10,
  elemTypeId = null,
}) => {
  try {
    const params = { search, page, limit }
    if (elemTypeId) params.elemTypeId = elemTypeId
    const response = await axios.get(`${API_URL}elemsubtypes/`, { params })
    return response.data
  } catch (error) {
    throw error.data
  }
}

export const createSubtype = async roleData => {
  try {
    const response = await axios.post(`${API_URL}elemsubtypes`, roleData, {
      headers: {
        'Content-Subtype': 'application/json',
      },
    })
    return response.data || {}
  } catch (error) {
    console.error('Error creating user app scope:', error)
    throw error
  }
}

export const updateSubtype = async (id, roleData) => {
  const response = await axios.put(`${API_URL}elemsubtypes/${id}`, roleData)
  return response.data || {}
}

export const deleteSubtype = async id => {
  const response = await axios.delete(`${API_URL}elemsubtypes/${id}`)
  return response.data || {}
}

export const getAllTypes = async ({ search = '', appId = null, no_paginate = true }) => {
  try {
    const params = { search, no_paginate }
    if (appId) params.appId = appId

    const response = await axios.get(`${API_URL}elemtypes/`, { params })
    return response.data
  } catch (error) {
    throw error.data
  }
}
